"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INVALID_TZ_GUESS = void 0;
var INVALID_TZ_GUESS = 'invalid-tz-guess';
exports.INVALID_TZ_GUESS = INVALID_TZ_GUESS;